import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryList: [],
  membershipList: [],
  singleMembership: [],
  invoiceList: [],
  userList: [],
  singleInvoice: [],
  settingsListData: [],
  customerMembershipList: [],
  getClientData: [],
  getSingleClient: [],
  getSingleCategory: [],
  getSevices: [],
  getSingleServiceId: [],
  getReportsData: [],
  getVatReportData: [],
  getSalesData: [],
  getSection1Data: [],
  getSection3Listing: [],
  getSection3single: [],
  getSection4Listing: [],
  getSection4single: [],
  getSection5Listing: [],
  getSection5single: [],
  getSection6single: [],
  getSection6Listing: [],
  getSection2listing: [],
  getdatawhychoose: [],
  getsinglewhychoose: [],
  getfaqlisting: [],
  getsinglefaq: [],
  getSalesReportdata: [],
  getPurchaseReportdata: [],
  getVatReportdata: [],
  getRevenueOverviewdata: [],
  getdashboard: [],
  getReferralData: [],
  thePopUpList:[],
  singlePopUp:[],
  getTicketsList:[],
  singleTicket:[],
  getAllUserTickets:[],
  singleUserTicket:[],
  getAllEnquiries:[],
  getSingleEnquiryById:[],
  seoList:[],
  seoHome:[],
  seoTagmanager:[],
  webhookUrl:[]
};

export const reusableSlice = createSlice({
  name: "reusable",
  initialState,
  reducers: {
    setGetCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
    setGetmemberShipList: (state, action) => {
      state.membershipList = action.payload;
    },
    GetPopUpList: (state, action) => {
      state.thePopUpList = action.payload;
    },
    setGetSingleTopUp: (state, action) => {
      state.singlePopUp = action.payload;
    },
    setGetSingleMembership: (state, action) => {
      state.singleMembership = action.payload;
    },
    setGetInvoiceList: (state, action) => {
      state.invoiceList = action.payload;
    },
    setGetUserList: (state, action) => {
      state.userList = action.payload;
    },
    setGetSingleInvoice: (state, action) => {
      state.singleInvoice = action.payload;
    },
    setSettingsListData: (state, action) => {
      state.settingsListData = action.payload;
    },
    setGetCustomerMembershipData: (state, action) => {
      state.customerMembershipList = action.payload;
    },
    setGetClientsData: (state, action) => {
      state.getClientData = action.payload;
    },
    setGetSingleClientId: (state, action) => {
      state.getSingleClient = action.payload;
    },
    setGetSingleCategory: (state, action) => {
      state.getSingleCategory = action.payload;
    },
    setGetServices: (state, action) => {
      state.getSevices = action.payload;
    },
    setGetServiceIdSingle: (state, action) => {
      state.getSingleServiceId = action.payload;
    },
    setGetReportsData: (state, action) => {
      state.getReportsData = action.payload;
    },
    setGetVatReportData: (state, action) => {
      state.getVatReportData = action.payload;
    },
    setGetSalesValueData: (state, action) => {
      state.getSalesData = action.payload;
    },
    setGetSection1Data: (state, action) => {
      state.getSection1Data = action.payload;
    },
    setGetSection3ListingData: (state, action) => {
      state.getSection3Listing = action.payload;
    },
    setGetSection3Single: (state, action) => {
      state.getSection3single = action.payload;
    },
    setGetSection4ListingData: (state, action) => {
      state.getSection4Listing = action.payload;
    },
    setGetSection4Single: (state, action) => {
      state.getSection4single = action.payload;
    },
    setGetSection5ListingData: (state, action) => {
      state.getSection5Listing = action.payload;
    },
    setGetSection5Single: (state, action) => {
      state.getSection5single = action.payload;
    },
    setGetSection6Single: (state, action) => {
      state.getSection6single = action.payload;
    },
    setGetSection6ListingData: (state, action) => {
      state.getSection6Listing = action.payload;
    },
    setGetSection2ListingData: (state, action) => {
      state.getSection2listing = action.payload;
    },
    setdatawhychoose: (state, action) => {
      state.getdatawhychoose = action.payload;
    },
    setgetsinglewhychoose: (state, action) => {
      state.getsinglewhychoose = action.payload;
    },
    setgetfaqlisting: (state, action) => {
      state.getfaqlisting = action.payload;
    },
    setgetsinglefaq: (state, action) => {
      state.getsinglefaq = action.payload;
    },
    setGetSalesReportData: (state, action) => {
      state.getSalesReportdata = action.payload;
    },
    setGetPurchaseReportData: (state, action) => {
      state.getPurchaseReportdata = action.payload;
    },
    setGetVatReportsData: (state, action) => {
      state.getVatReportdata = action.payload;
    },
    setgetRevenuedata: (state, action) => {
      state.getRevenueOverviewdata = action.payload;
    },
    setGetDashboardListData: (state, action) => {
      state.getdashboard = action.payload;
    },
    setGetReferralData: (state, action) => {
      state.getReferralData = action.payload;
    },
    setGetTicketsList: (state, action) => {
      state.getTicketsList = action.payload;
    },
    setgetsingleTicket: (state, action) => {
      state.singleTicket = action.payload;
    },
    setAllUserTicketList :(state, action)=>{
      state.getAllUserTickets = action.payload
    },
    setgetsingleUserTicket: (state, action) => {
      state.singleUserTicket = action.payload;
    },
    setgetAllEnquiries: (state, action) => {
      state.getAllEnquiries = action.payload;
    },
    setgetsingleEnquiryById: (state, action) => {
      state.getSingleEnquiryById = action.payload;
    },
    setSeoList: (state, action) => {
      state.seoList = action.payload;
    },
    setSeoHome: (state, action) => {
      state.seoHome = action.payload;
    },
    setSeoTagmanager: (state, action) => {
      state.seoTagmanager = action.payload;
    },
    setWebhookurl: (state, action) => {
      state.webhookUrl = action.payload;
    },
  },
});

export const {
  setWebhookurl,
  setSeoTagmanager,
  setGetUserList,
  setGetSalesValueData,
  setGetServiceIdSingle,
  setGetSingleClientId,
  setGetClientsData,
  setGetInvoiceList,
  setGetCategoryList,
  setGetmemberShipList,
  setGetSingleMembership,
  setGetSingleInvoice,
  setSettingsListData,
  setGetCustomerMembershipData,
  setGetSingleCategory,
  setGetServices,
  setGetReportsData,
  setGetVatReportData,
  setGetSection1Data,
  setGetSection3ListingData,
  setGetSection3Single,
  setGetSection4ListingData,
  setGetSection5ListingData,
  setGetSection4Single,
  setGetSection5Single,
  setGetSection6Single,
  setGetSection6ListingData,
  setGetSection2ListingData,
  setdatawhychoose,
  setgetsinglewhychoose,
  setgetfaqlisting,
  setgetsinglefaq,
  setGetSalesReportData,
  setGetPurchaseReportData,
  setGetVatReportsData,
  setgetRevenuedata,
  setGetDashboardListData,
  setGetReferralData,
  GetPopUpList,
  setGetSingleTopUp,
  setGetTicketsList,
  setgetsingleTicket,
  setgetsingleUserTicket,
  setAllUserTicketList,
  setgetAllEnquiries,
  setgetsingleEnquiryById,
  setSeoList,
  setSeoHome
} = reusableSlice?.actions;
